import React, { PureComponent } from 'react';
import { GlobalStyle, Colors } from 'stylecomponents';
import CupoyRouter from 'components/commons/router/CupoyRouter';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import styled from 'styled-components';
import TimeFormat from '../commons/TimeFormat';
import CupoyNoteContent from '../commons/CupoyNoteContent';
import MarkdownContentView from 'cupoy-md-editor/lib/preview';

const ErrorContainer = GlobalStyle.BasicBlock.extend`
`;

const Content = GlobalStyle.BasicBlock.extend`
  padding: 30px;
`;
const Btn = GlobalStyle.BasicBtn.extend`
  width: 150px;
  margin: 10px auto 0;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 26px;
  line-height: 1.5em;
  color: ${Colors.Dark2};
`;
const Time = styled.div`
  color: ${Colors.Dark5};
  font-size: 16px;
  line-height: 1.5em;
  margin: 10px 0 20px;
`;

/**
 * 公告內容
 */
class NewsContent extends PureComponent {

  constructor(props) {
    super(props);

    const routerState = CupoyRouter.getCurrent();
    const { params } = routerState;
    const { id } = params;

    this.state = {
      isLoading: false,
      isError: false,
      isLoaded: false,
      id,
    };
  }

  componentDidMount() {
    window.scrollTo({ top: 0 });
    this.getBulletinDetail();
  }

  getBulletinDetail = () => {

    const { id } = this.state;

    this.setState({
      isLoading: true,
      isError: false,
    }, () => {

      this.props.bulletinActions.getBulletinDetail({
        bulletinid: id,
      }).then((result) => {
        this.setState({
          isLoading: false,
          isLoaded: true,
        });
      }).catch(err => {
        console.log(err);
        this.setState({
          isLoading: false,
          isError: true,
        });
      });
    });

  }

  goBack = () => {
    this.props.history.goBack();    
  }

  render() {

    const { id, isLoaded, isLoading } = this.state;
    const { itemMap } = this.props;

    const news = itemMap[id] || {};

    const {
      title = '',
      bulletincontent,
      publishtime,
      note_editor_type,
      markdown
    } = news;

    if(isLoading)
      return this.renderLoading();

    if(isLoaded && !bulletincontent && !markdown)
      return this.renderError();

    return (
      <div>
        <Content>
          <Title>{title.trim()}</Title>
          <Time>
            發布日期：
            <TimeFormat
              format='timeString'
              time={publishtime}
            />
          </Time>
          {note_editor_type === 1 ?
              <MarkdownContentView mdcontent={markdown} />      
            :<CupoyNoteContent html={bulletincontent} />
          }
          <Btn onClick={this.goBack}>回上頁</Btn>
        </Content>
      </div>
    )
  }

  renderLoading = () => (
    <GlobalStyle.LoadingContainer>
      <GlobalStyle.Spin />
    </GlobalStyle.LoadingContainer>
  )

  renderError = () => (
    <div>
      <ErrorContainer>
        <GlobalStyle.ErrorContainer>
          <GlobalStyle.ErrorContainerTitle>
            找不到新聞
          </GlobalStyle.ErrorContainerTitle>
          <GlobalStyle.ErrorContainerDesription>
            沒有此篇新聞，請重新整理後再嘗試。
          </GlobalStyle.ErrorContainerDesription>
        </GlobalStyle.ErrorContainer>
      </ErrorContainer>
    </div>
  )
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
  return {
      itemMap: state.bulletin.itemMap,
      isloading: state.bulletin.isloading,
  };
};

/*--------------------------
  Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
  return {
      webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
      bulletinActions: bindActionCreators(actionCreators.bulletinActionCreators, dispatch),
  };
};

/*--------------------------
  export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
  forwardRef: true
})(NewsContent);